import css from 'styled-jsx/css';
import { screen } from 'components/styles/variables';

export default css`
  .dealer-page {
    padding-top: 7px;
    padding-left: 15px;
    padding-right: 15px;
  }

  @media (min-width: ${screen.smMin}) {
    .dealer-page {
      width: 750px;
      margin-right: auto;
      margin-left: auto;
    }
  }

  @media (min-width: ${screen.mdMin}) {
    .dealer-page {
      width: 970px;
    }
  }

  @media (min-width: ${screen.lgMin}) {
    .dealer-page {
      width: 1200px;
    }
  }
`;
